// Configuración específica de cada despliegue.
// REACT_APP_CLIENT se fija al arrancar/compilar (ARENA por defecto).
const CLIENT_CONFIG = {
  ARENA: {
    endpoint: "https://api-gestrescan.com",
    //endpoint: "http://localhost:8000",
    signatures: ["FRANCISCO", "GONZALO", "GUILLERMO", "JORGE", "KIRIAN"],
    nonErasableEmployeeId: "0",
    defaultTypeOfDocument: "4",
    nonErasableUserAccountId: "17",
    nonErasableRoleId: "13",
    nonErasableTypesDiId: "4",
    nonErasableTicketsFormatId: "4",
    maxPdf: 25,
  },
  BENTAHOR: {
    endpoint: "https://api-bentahor.gestrescan.com",
    signatures: ["BENTAHOR", "DIEGO", "MARIO", "ROBERTO", "SANTIAGO"],
    nonErasableEmployeeId: "2",
    defaultTypeOfDocument: "5",
    nonErasableUserAccountId: "7",
    nonErasableRoleId: "5",
    nonErasableTypesDiId: "3",
    nonErasableTicketsFormatId: "3",
    maxPdf: 20,
  },
};

const requestedClient = (process.env.REACT_APP_CLIENT || "ARENA").toUpperCase();

if (!CLIENT_CONFIG[requestedClient]) {
  throw new Error(
    `REACT_APP_CLIENT desconocido: "${requestedClient}". Valores permitidos: ${Object.keys(CLIENT_CONFIG).join(", ")}`
  );
}

const clientConfig = CLIENT_CONFIG[requestedClient];

export const CLIENTEFIRMA = requestedClient;
export const ENDPOINT = clientConfig.endpoint;
export const [SIGN_1, SIGN_2, SIGN_3, SIGN_4, SIGN_5] = clientConfig.signatures;

export const CONFIRM_CODE = "Confirmar";
export const DEFAULT_STORE = "1";
export const DEFAULT_ROLE = "3";
export const NON_ERASABLE_STATUSTYPE_ID = "10";//OK
export const NON_ERASABLE_REASONTYPE_ID = "26";//OK
export const NON_ERASABLE_STORE_ID = "3";//OK
export const NON_ERASABLE_CODELER_ID= "834";//ok
export const NON_ERASABLE_OPTTYPE_ID="21";//ok
export const NON_ERASABLE_TREATMENTTYPE_ID= "85";//ok
export const NON_ERASABLE_PROCESSTYPE_ID= "29";//ok
export const NON_ERASABLE_DANGERROUS_ID= "15";//ok
export const NON_ERASABLE_COLOR_ID= "137";//ok
export const NON_ERASABLE_COMMUNITY_ID= "20";//ok
export const NON_ERASABLE_COUNTRY_ID= "247";//ok
export const NON_ERASABLE_DESCRIPTION_ID= "2";//ok
export const NON_ERASABLE_DOCUMENTTYPES_ID= "4";//ok
export const NON_ERASABLE_LANGUAGE_ID= "2";//ok
export const NON_ERASABLE_POSTALCODE_ID= "14617";//ok
export const NON_ERASABLE_PROVINCE_ID= "53";//ok
export const NON_ERASABLE_ROADTYPES_ID= "74";//ok
export const NON_ERASABLE_ARTICLESBUTTON_ID= "49";//ok
export const NON_ERASABLE_EMPLOYEE_ID = clientConfig.nonErasableEmployeeId;
export const NON_ERASABLE_DRIVER_ID= "0";//ok
export const NON_ERASABLE_TYPESOFTAXES_ID="12";//ok
export const NON_ERASABLE_ARTICLES_ID="863";//ok
export const NON_ERASABLE_PAYMEMTTYPE_ID="4";//ok 
export const DEFAULTSTORETYPESDI = "1";//ok
export const DEFAULTEMPLOYEE= "1";//ok
export const DEFAULTTYPEOFDOCUMENT = clientConfig.defaultTypeOfDocument;
export const DEFAULTLANGUAGE= "1";//ok
export const DEFAULTCOLOR= "2";//ok
export const DEFAULTCOLOREMPLOYEE= "50";//ok 
export const LIMIT_PAGE_SIZE_SLIDE= "1000";//ok 
export const LIMIT_PAGE_BIG = "10000";//ok 
export const DEFAULT_TYPESDI= "1";//ok 
export const NON_ERASABLE_COMPANYTYPE_ID= "18";//ok 
export const NON_ERASABLE_MUNICIPALITY_ID= "8133";//ok 
export const NON_ERASABLE_INCIDENTTYPE_ID= "12";//ok 
export const NON_ERASABLE_SLATYPE_ID= "9";//ok  
export const NON_ERASABLE_RESOLUTIONTYPE_ID= "7";//ok 
export const LIMIT_PAGE = "2000";
export const NON_ERASABLE_SEMITRAILERTYPE_ID="6";
export const NON_ERASABLE_CRANEMODEL_ID="3";

export const NON_ERASABLE_USERACCOUNT_ID = clientConfig.nonErasableUserAccountId;
export const NON_ERASABLE_ROLER_ID = clientConfig.nonErasableRoleId;
export const NON_ERASABLE_TYPESDI_ID = clientConfig.nonErasableTypesDiId;
export const NON_ERASABLE_TICKETSFORMAT_ID = clientConfig.nonErasableTicketsFormatId;

export const TEXT_SIGN_1= "FIRMA "+SIGN_1;//ok 
export const TEXT_SIGN_2= "FIRMA "+SIGN_2;//ok 
export const TEXT_SIGN_3= "FIRMA "+SIGN_3;//ok 
export const TEXT_SIGN_4= "FIRMA "+SIGN_4;//ok 
export const TEXT_SIGN_5= "FIRMA "+SIGN_5;//ok 
export const MAX_PDF = clientConfig.maxPdf;
export const MAX_ZIP= 100;

export const CANVAS_SIZE = 170;
export const CLIENT_CANVAS_WIDTH = 400;
export const CLIENT_CANVAS_HEIGHT = 180;
export const CLIENT_CANVAS_DOUBLE_HEIGHT = 250;
